import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { withTranslation } from "react-i18next";

import getChartData from "utils/getChartData";
import { chartColors } from "common/constant";

const SopGERCChart = ({ sopGERCData, t }) => {
  const initialOption = {
    chart: {
      height: 350,
      type: "bar",
      stacked: true,
    },
    dataLabels: {
      enabled: true,
    },
    xaxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 20,
        borderRadiusApplication: "end", // 'around', 'end'
        borderRadiusWhenStacked: "last", // 'all', 'last'
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    legend: {
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => {
        const total = opts.w.globals.series[opts.seriesIndex].reduce(
          (acc, curr) => acc + curr,
          0
        );
        return [seriesName, " - ", total];
      },
    },
    colors: chartColors,
  };

  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState(initialOption);
  const [sopDuration, setSopDuration] = useState("firstHalf");

  useEffect(() => {
    if (sopGERCData) {
      const { barChartData, barChartLabels } = getChartData(
        sopGERCData[sopDuration],
        "consumerCategoryResponses",
        "consumerCategory",
        "count",
        "name"
      );
      const seriesData = Object.entries(barChartData).map(([key, value]) => ({
        name: key,
        data: value,
      }));

      setSeries(seriesData);
      setOptions((prev) => ({
        ...prev,
        xaxis: { ...prev.xaxis, categories: barChartLabels },
      }));
    }
  }, [sopGERCData, sopDuration]);

  return (
    <Card className="p-0">
      <CardHeader
        title={
          <Grid container>
            <Grid item xs={8}>
              <Typography variant="subtitle1" fontWeight={700}>
                {t("Connection Status")}
              </Typography>
            </Grid>
            <Grid item xs={4} className="text-end">
              <Button
                variant={sopDuration === "firstHalf" ? "contained" : "text"}
                className="me-1"
                size="small"
                onClick={() => {
                  setSopDuration("firstHalf");
                }}
              >
                {t("First Half")}
              </Button>
              <Button
                variant={sopDuration === "secondHalf" ? "contained" : "text"}
                size="small"
                onClick={() => {
                  setSopDuration("secondHalf");
                }}
              >
                {t("Second Half")}
              </Button>
              <Button
                variant={sopDuration === "annual" ? "contained" : "text"}
                size="small"
                onClick={() => {
                  setSopDuration("annual");
                }}
              >
                {t("Annual")}
              </Button>
            </Grid>
          </Grid>
        }
        className="border-bottom"
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={450}
        />
      </CardContent>
    </Card>
  );
};

SopGERCChart.propTypes = {
  sopGERCData: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(SopGERCChart);
